// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VYyA","questions":"styles_questions__KkVTb","footer":"styles_footer__181Rz"};